module.exports = __webpack_public_path__ + "static/media/boldo.d63dfe53.png";